import {Component, Input} from '@angular/core';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-invalid-value-error-message',
  templateUrl: './invalid-value-error-message.component.html',
  styleUrls: ['./invalid-value-error-message.component.css']
})
export class InvalidValueErrorMessageComponent {

  @Input() message;
  faExclamationTriangle = faExclamationTriangle;
  constructor() { }

}
